import {
  JOB_REQUEST_REQUEST, JOB_REQUEST_SUCCESS, JOB_REQUEST_FAIL
} from "../constants/AuthConstant";

const initialState = {
  loading: false,
  action: "Job Action",
  result: [],
  msg: "",
  error: "",
};

const JobRequestReducer = (state = initialState, action) => {
  switch (action.type) {
    case JOB_REQUEST_REQUEST:
      return {
        ...state,
        loading: action.payload,
      };
    case JOB_REQUEST_SUCCESS:
      return {
        ...state,
        result: action.result.data,
        loading: action.payload,
        msg: action.msg,
      };
    case JOB_REQUEST_FAIL:
      return {
        ...state,
        error: action.error,
        loading: action.payload,
        msg: action.msg,
      };

    default:
      return state;
  }
};

export default JobRequestReducer;
